import { Story } from '../../types/story';

export const oxfordLibrary: Story = {
  id: 'oxford-library',
  title: 'The Bodleian After Hours',
  excerpt: 'A late-night research session in Oxford\'s oldest library leads to a forbidden encounter between a visiting scholar and a mysterious don.',
  city: 'Oxford',
  publishDate: '2025-12-18',
  readTime: '13 min read',
  tags: ['♀♂', 'academia', 'library', 'forbidden'],
  categories: ['forbidden', 'romantic'],
  intensity: 2,
  content: `The Bodleian closes at 10 PM, but if you have the right credentials—and the right excuses—you can stay later. Much later.

I'd been granted special access for my research on medieval manuscripts, which meant I had the Duke Humfrey's Reading Room essentially to myself after hours. Just me, a thousand years of history, and the kind of silence that makes you aware of your own breathing.

It was past midnight when I heard footsteps.

I looked up from my Latin text, annoyed. The whole point of working this late was to avoid other people. But then he appeared at the end of the aisle, and my annoyance shifted into something else entirely.

He was tall, maybe late thirties, wearing a dark wool coat over what looked like a rumpled shirt and tie. His hair was slightly too long for a proper don, dark and pushed back like he'd been running his hands through it. He had that particular Oxford look—expensive education, cheaper lifestyle, the kind of person who'd choose books over sleep.

"You're not supposed to be here," I said.

"Neither are you." His voice was low, cultured, with just a hint of amusement. "But here we both are."

"I have permission."

"So do I." He moved closer, his eyes scanning the books I had spread across the desk. "Medieval hagiography. Interesting choice for a Friday night."

"It's research."

"Everything's research if you frame it right." He picked up one of my books, examined it. "You're American."

"Visiting scholar. Columbia. You?"

"Professor of Medieval History. Magdalen College." He set the book down carefully. "Sebastian."

"Emma."

We stood there for a moment, the silence stretching between us. The library felt different with him in it—smaller, warmer, charged with something I couldn't quite name.

"I come here when I can't sleep," he said. "Which is most nights, lately. There's something about this place after dark. Like the books are more honest when no one's watching."

"That's either very poetic or very pretentious."

He smiled. "Can't it be both?"

I laughed despite myself. "What are you working on?"

"Officially? A monograph on ecclesiastical power structures in the fourteenth century. Unofficially?" He gestured vaguely. "Avoiding my office, my colleagues, and the crushing weight of academic bureaucracy."

"So you're hiding."

"We're all hiding from something." He pulled out the chair across from me. "May I?"

I should've said no. Should've maintained professional boundaries, kept my focus on my research. Instead, I nodded.

He sat, and we started talking. About manuscripts, about Oxford, about the peculiar loneliness of academic life. He was brilliant—the kind of brilliant that made you want to argue with him just to see how his mind worked. Sharp, self-deprecating, with a dry wit that caught me off guard.

"You know what's funny?" he said after we'd been talking for an hour. "I've been teaching here for ten years. I've given hundreds of lectures, supervised dozens of students. But I can't remember the last time I had a conversation this interesting."

"Maybe you're just talking to the wrong people."

"Maybe I am." His eyes met mine, and there was something in his gaze that made my pulse quicken. "Or maybe I've been waiting for the right American to break into my library."

"I didn't break in. I have credentials."

"Semantics." He leaned back in his chair. "Tell me something, Emma from Columbia. Why are you really here at midnight? And don't say research."

"Why does anyone do anything at midnight? Because daylight makes everything too real."

He nodded slowly. "That's honest."

"Your turn. Why are you really here?"

"Because my flat is too quiet. Because I'm tired of my own thoughts. Because..." He paused. "Because sometimes I need to remember why I fell in love with this place before it consumed me entirely."

There was something raw in his voice, something that made me want to reach across the table and touch his hand. I didn't. But I wanted to.

"Show me something," I said instead. "Something you love about this place."

He stood. "Come with me."

I followed him through the darkened library, past rows of ancient books, up a narrow staircase I'd never noticed before. He moved with the confidence of someone who knew every corner of this building, every secret passage.

We ended up in a small room I didn't recognize—more of an alcove, really, with a single window overlooking Radcliffe Square. The view was stunning, all Gothic spires and gaslit streets.

"This is where I come when I need to think," he said quietly. "No one knows about it except the night security guard, and he pretends not to notice."

"It's beautiful."

"It is." But he wasn't looking at the view. He was looking at me.

The air between us shifted. Became heavier, more charged. I could feel my heart hammering in my chest.

"Emma," he said, his voice rough. "I should probably tell you that I'm not very good at this."

"At what?"

"At pretending I don't want to kiss you."

I should've stepped back. Should've maintained professional distance, remembered that I was a visiting scholar and he was a professor and this was a terrible idea.

Instead, I closed the distance between us.

"Then don't pretend," I said.

He kissed me like he'd been thinking about it all night—hungry, urgent, his hands cupping my face like I was something precious. I kissed him back just as hard, my fingers tangling in his hair, pulling him closer.

We stumbled backward until my back hit the wall. His mouth moved to my neck, and I gasped, my head falling back.

"We shouldn't—" he started.

"I know."

"This is completely inappropriate—"

"I know."

"If anyone found out—"

I pulled his mouth back to mine. "Then let's make sure they don't."

He groaned, his hands sliding under my sweater, his touch sending electricity through my skin. I tugged at his tie, loosening it, then started on the buttons of his shirt.

"Here?" he asked, breathless.

"You have a better idea?"

"My office. Five minutes away."

We made it in three.

His office was exactly what I expected—books everywhere, papers stacked haphazardly, a leather couch that had seen better days. He locked the door behind us, and then we were on each other again, desperate and reckless.

Clothes came off in a tangle of hands and mouths. He laid me back on the couch, his body covering mine, and for a moment, we just looked at each other.

"You're sure?" he asked.

"Yes. Are you?"

"God, yes."

He kissed me again, slower this time, his hands exploring my body with a reverence that made me ache. When his fingers slid between my legs, I arched into his touch, gasping.

"Tell me what you want," he murmured against my ear.

"You. Inside me. Now."

He reached for his wallet, pulled out a condom. I watched him roll it on, my mouth dry with anticipation.

When he finally pushed inside me, we both groaned. He moved slowly at first, letting me adjust, his eyes locked on mine.

"Okay?" he asked.

"More than okay. Don't stop."

He didn't. He set a rhythm that was perfect—deep, steady, building. I wrapped my legs around him, meeting each thrust, my nails digging into his shoulders.

"Fuck," he breathed. "You feel incredible."

"Harder," I gasped. "Please."

He obliged, his hips snapping forward, the couch creaking beneath us. I could feel the pressure building, that tight coil of pleasure low in my belly.

"Touch yourself," he said, his voice rough. "I want to watch you come."

I slid my hand between us, my fingers finding my clit. The added sensation made me cry out.

"That's it," he encouraged. "Just like that."

It didn't take long. I came with a broken moan, my body clenching around him. He followed seconds later, burying his face in my neck as he shuddered through his release.

We lay there afterward, tangled together on his narrow couch, both of us breathing hard.

"Well," he said eventually. "That was..."

"Unprofessional?"

"I was going to say extraordinary. But unprofessional works too."

I laughed, pressing my face against his chest. "What do we do now?"

"Honestly? I have no idea." He ran his fingers through my hair. "How long are you in Oxford?"

"Three more months."

"Three months." He was quiet for a moment. "We could pretend this never happened. Keep it professional."

"We could."

"Or..."

"Or?"

He tilted my chin up, his eyes serious. "Or we could see where this goes. Carefully. Discreetly. But... see where it goes."

"That's a terrible idea."

"Probably the worst I've ever had."

"I'm in."

He smiled, and it transformed his whole face. "Yeah?"

"Yeah."

We stayed in his office until dawn, talking and touching and occasionally doing more than talking. When the first light started creeping through his window, he walked me back to my college, both of us disheveled and exhausted and stupidly happy.

"Same time next week?" he asked at my door.

"The library or your office?"

"Dealer's choice."

I kissed him one more time. "I'll surprise you."

Three months turned into six. Six months turned into a year. I extended my fellowship, then applied for a permanent position. He introduced me to his colleagues as "Dr. Chen, the brilliant medievalist from Columbia," and no one suspected that we spent our nights tangled together in his flat in Jericho.

Eventually, we stopped hiding. Eventually, it didn't matter.

But sometimes, late at night, we still meet in the Bodleian after hours. We sit in that hidden alcove, looking out over Radcliffe Square, and remember the night a chance encounter in a library changed everything.

Because sometimes the best things happen after midnight. Sometimes a forbidden kiss in a dark library is the beginning of everything. Sometimes Oxford isn't just a place you study—it's the place where you find exactly what you didn't know you were looking for.

And sometimes, "you're not supposed to be here" is exactly the right way to start.`
};
